import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function FAQ({ items = [] }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const renderAnswer = (answer) => {
    // plain string
    if (typeof answer === "string") {
      return (
        <p
          style={{
            marginTop: 25,
            fontSize: "15px",
            lineHeight: 1.6,
            fontFamily: "Inter",
            fontWeight: "300",
          }}
        >
          {answer}
        </p>
      );
    }

    // legacy object: { intro, bullets, outro }
    if (answer && typeof answer === "object" && !Array.isArray(answer)) {
      return (
        <>
          {answer.intro ? (
            <p style={{ marginTop: 25, fontSize: "15px", lineHeight: 1.6, fontFamily: "Inter", fontWeight: "300" }}>
              {answer.intro}
            </p>
          ) : null}

          {Array.isArray(answer.bullets) && answer.bullets.length > 0 ? (
            <ul style={{ marginTop: 12, paddingLeft: 22, fontSize: "15px", fontFamily: "Inter", lineHeight: 1.6 }}>
              {answer.bullets.map((b, i) => (
                <li key={i} style={{ marginBottom: 8, fontFamily: "Inter", fontWeight: "300" }}>{b}</li>
              ))}
            </ul>
          ) : null}

          {answer.outro ? (
            <p style={{ marginTop: 12, fontSize: "15px", lineHeight: 1.6, fontFamily: "Inter", fontWeight: "300" }}>
              {answer.outro}
            </p>
          ) : null}
        </>
      );
    }

    // flexible blocks array: [{ type: 'p'|'ul', text, items }]
    if (Array.isArray(answer)) {
      return answer.map((block, i) => {
        if (block.type === "ul" && Array.isArray(block.items)) {
          return (
            <ul key={i} style={{ marginTop: 12, paddingLeft: 22, fontSize: "15px", fontFamily: "Inter", lineHeight: 1.6 }}>
              {block.items.map((it, j) => (
                <li key={j} style={{ marginBottom: 8, fontFamily: "Inter", fontWeight: "300" }}>{it}</li>
              ))}
            </ul>
          );
        }
        // default to paragraph
        return (
          <p key={i} style={{ marginTop: 12, fontSize: "15px", lineHeight: 1.6, fontFamily: "Inter", fontWeight: "300" }}>
            {block.text}
          </p>
        );
      });
    }

    return null;
  };

  return (
    <div className="faq-section">
      <h2>Frequently Asked <span style={{ color: "#FE9A00" }}>Questions</span></h2>
      <p>Everything you need to know about our platform</p>

      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        {items.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div key={index} className="faq-item" style={{ marginBottom: 18 }}>
              <button
                onClick={() => toggle(index)}
                style={{
                  width: "100%",
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  textAlign: "left",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                <span
                  className="faq-question"
                  style={{ color: isOpen ? "#FE9A00" : "white" }}
                >
                  {item.question}
                </span>

                <FontAwesomeIcon
                  icon={faChevronRight}
                  style={{
                    fontSize: "16px",
                    transition: "transform 0.25s ease",
                    transform: isOpen ? "rotate(-90deg)" : "rotate(0deg)",
                    color: isOpen ? "#FE9A00" : "white",
                  }}
                  className="faq-icon"
                />
              </button>

              <div
                style={{
                  maxHeight: isOpen ? "800px" : "0px",
                  overflow: "hidden",
                  transition: "max-height 0.35s ease",
                }}
              >
                {renderAnswer(item.answer)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}